import { Trans, useLingui } from '@lingui/react/macro';
import React from 'react';
import InfoIcon from 'ud-ui/components/icon/info-icon';
import UDTippy from 'ud-ui/components/tippy';

/**
 * Подсказка «кто такие Игрок №1 и №2» у селектора игрока в плейсхолдере события.
 *
 * Роли повторяют контракт `MatchEvent.players` (`shared/types/match-event.ts`): у «паса и гола»
 * порядок `[пасующий, забивающий]`, у остальных событий игрок один. У замены порядок ничем
 * не закреплён — он такой, в каком игроков внесли в протокол, поэтому подсказка так и говорит.
 */
function PlayerRoleHint() {
  const { t } = useLingui();

  const content = (
    <div className="flex max-w-64 flex-col gap-1.5 text-left">
      <div className="font-semibold">
        <Trans>Кто такие Игрок №1 и №2</Trans>
      </div>
      <div>
        <Trans>
          <b>Пас и гол:</b> №1 — пас, №2 — гол
        </Trans>
      </div>
      <div>
        <Trans>
          <b>Замена:</b> №1 и №2 — в том порядке, в каком их внесли в протокол
        </Trans>
      </div>
      <div>
        <Trans>
          <b>Остальные события:</b> только №1 — тот, кто забил, получил карточку, сфолил… №2 останется пустым
        </Trans>
      </div>
    </div>
  );

  return (
    <UDTippy content={content} placement="left" size="xs">
      <span
        role="img"
        tabIndex={0}
        aria-label={t`Кто такие Игрок №1 и №2`}
        className="text-inkMuted inline-flex cursor-help items-center"
      >
        <InfoIcon />
      </span>
    </UDTippy>
  );
}

export default PlayerRoleHint;
